import * as React from 'react';

import {Stack} from 'shells/layout/stack/stack';
import {LoadingText} from 'shells/loading-placeholder/loading-text';
import {Switch} from 'shells/switch/switch';
import {Body} from 'shells/typography/body';

import {useGetChatSettings, useUpdateEnableChat} from '../../graphql/hooks';

export function EnableChatSwitch() {
    const {enableChat} = useUpdateEnableChat();
    const {chatSettings, refetch, isLoading: isLoadingChatSettings} = useGetChatSettings();

    const handleChange = () => {
        enableChat({
            isChatEnabled: !chatSettings.isChatEnabled,
        }).then(refetch);
    };

    if (isLoadingChatSettings && !chatSettings) {
        return <LoadingText height={31} width={120} />;
    }

    return (
        <Stack isHorizontal={true} spacing={8}>
            <Switch
                onChange={handleChange}
                isRounded={true}
                isOn={chatSettings.isChatEnabled}
                isSmall={true}
            />
            <Body size='small'>Visible on website</Body>
        </Stack>
    );
}
